module.exports = __webpack_public_path__ + "img/swich_banner.png";